/**
 * Created by ZengFanHui on 18/05/04.
 */
import * as types from './mutations-types'

export const clearAllData = function ({ commit }) {
  commit(types.SET_MENU_LIST, [])
  commit(types.SET_MENU_ACTIVE_NAME, '')
  commit(types.SET_SUB_MENU_ACTIVE_NAME, '')
  commit(types.SET_NEWTABS, '')
  commit(types.SET_TABS, [])
  commit(types.SET_SUB_MENU_LIST, [])
  commit(types.SET_USERINFO, [])
  commit(types.SET_ROLES, [])
  commit(types.SET_CURRENT_ROLES, [])
}
